// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Avatar-cls1___213e234d2ea4e4e5776{/*!*/}.Avatar-cls2___189aae43baa38646e98{aspect-ratio:1/1;width:100%;border-radius:50%;background:#f8f8fb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Avatar-cls1___213e234d2ea4e4e5776",
	"cls2": "Avatar-cls2___189aae43baa38646e98 Avatar-cls1___213e234d2ea4e4e5776"
};
export default ___CSS_LOADER_EXPORT___;
